import { BackgroundColours } from '@honeycomb/data';
const { Primary, Accent, Secondary } = BackgroundColours;
export function getHeadingTextColor(bgColor) {
    if (!bgColor) {
        return 'text.heading';
    }
    switch (bgColor.name) {
        case Primary:
        case Accent:
        case Secondary:
            return 'common.white';
        default:
            return 'text.heading';
    }
}
export function getSubHeadingTextColor(bgColor) {
    if (!bgColor) {
        return 'text.body';
    }
    switch (bgColor.name) {
        case Primary:
        case Accent:
        case Secondary:
            return 'common.white';
        default:
            return 'text.body';
    }
}
export function getBorderColor(bgColor, palette) {
    if (!bgColor) {
        return palette.text.body;
    }
    switch (bgColor.name) {
        case Primary:
        case Accent:
        case Secondary:
            return palette.common.white;
        default:
            return palette.text.body;
    }
}
export function getIntroTextHeaderColor(bgColor) {
    if (!bgColor) {
        return 'accent.base';
    }
    switch (bgColor.name) {
        case Primary:
        case Accent:
        case Secondary:
            return 'common.white';
        default:
            return 'accent.base';
    }
}
